import { css } from '@emotion/core';
import { variables, tokens, globalTokens } from '@domain-group/fe-brary';
var font = variables.font;
var colors = tokens.colors;
var applyButtonHeight = '55px';
export var container = {
  name: "1f8sh1y",
  styles: "position:relative;width:100%;height:100%;"
};
export var scrollableRegion = hasApply => /*#__PURE__*/css("overflow-y:auto;height:100%;-webkit-overflow-scrolling:touch;", hasApply && /*#__PURE__*/css("height:calc(100% - ", applyButtonHeight, ");"));
export var toolbarButton = {
  name: "gji0ls",
  styles: "display:inline-block;position:absolute;height:24px;top:50%;transform:translateY(-50%);padding:0;border:0;background-color:transparent;&:focus{outline:0;}"
};
export var closeButton = extraStyles => /*#__PURE__*/css("left:0;margin:auto 16px;", extraStyles);
export var closeButtonIcon = {
  name: "1p66nw2",
  styles: "display:block;width:24px;height:24px;"
};
export var rightButton = {
  name: "10pulkw",
  styles: "height:24px;right:0;margin:0 16px;"
};
export var backButton = {
  name: "74dba",
  styles: "left:0;margin:0 16px 0 8px;"
};
export var backButtonIcon = {
  name: "1s1rqrt",
  styles: "display:inline-block;width:24px;height:24px;vertical-align:middle;"
};
export var backButtonText = /*#__PURE__*/css("font-family:", font.bodyFontFamily, ";font-size:", font.smallFontSize, ";vertical-align:middle;color:", colors.neutral.heavy.default, ";font-weight:600;");
export var rightButtonText = /*#__PURE__*/css("font-family:", font.bodyFontFamily, ";font-size:", font.smallFontSize, ";vertical-align:middle;");
export var heading = extraStyles => /*#__PURE__*/css("position:relative;width:100%;height:56px;border-bottom:1px solid ", colors.neutral.subdued.default, ";text-align:center;font-family:", font.bodyFontFamily, ";font-size:", font.baseFontSize, ";font-weight:600;color:", colors.neutral.heavy.default, ";", extraStyles);
export var title = extraStyles => /*#__PURE__*/css("position:absolute;top:50%;transform:translate(-50%,-50%);", extraStyles);
export var applyContainer = /*#__PURE__*/css("width:100%;height:", applyButtonHeight, ";padding:6px 16px 9px;background-color:", globalTokens.colors.white, ";position:absolute;bottom:0;");
export var applyButton = /*#__PURE__*/css("color:", globalTokens.colors.white, ";background-color:", colors.interactive.base.default, ";border-radius:2px;height:100%;width:100%;font-family:", font.bodyFontFamily, ";font-size:", font.baseFontSize, ";font-weight:600;border:0;");